import { NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule  } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatListModule  } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@NgModule({
  imports: [MatButtonModule, MatCheckboxModule, MatListModule, MatToolbarModule, MatFormFieldModule,
    MatInputModule, MatDividerModule, MatButtonToggleModule, MatRadioModule, MatIconModule,
    MatMenuModule, MatTabsModule, MatSelectModule, MatDialogModule, MatTableModule, MatPaginatorModule, MatDatepickerModule,
    MatNativeDateModule, MatChipsModule, MatSnackBarModule, MatExpansionModule, MatTooltipModule,
    MatProgressSpinnerModule],
  exports: [MatButtonModule, MatCheckboxModule, MatListModule, MatToolbarModule, MatFormFieldModule,
    MatInputModule, MatDividerModule, MatButtonToggleModule, MatRadioModule, MatIconModule,
    MatMenuModule, MatTabsModule, MatSelectModule, MatDialogModule, MatTableModule, MatPaginatorModule, MatDatepickerModule,
    MatNativeDateModule, MatChipsModule, MatSnackBarModule, MatExpansionModule, MatTooltipModule,
    MatProgressSpinnerModule],
})
export class MaterialModule {
}
